import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import {
  getDarkModeVatFallbackPath,
  isDarkModeFacility
} from '../utils/facilityMode';

/**
 * Blocks VAT Summary / Output / Input / Reconciliation when a Dark Mode
 * facility is selected. Redirects to Credit Notes & Refunds before the
 * restricted page mounts (no report API calls).
 */
export default function DarkModeVatRestriction({ children }) {
  const { selectedFacility } = useAuth();

  if (isDarkModeFacility(selectedFacility)) {
    return <Navigate to={getDarkModeVatFallbackPath()} replace />;
  }

  return <>{children}</>;
}

DarkModeVatRestriction.propTypes = {
  children: PropTypes.node
};
